import script from "./ShoppingPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShoppingPreview.vue?vue&type=script&lang=ts&setup=true"

import "./ShoppingPreview.vue?vue&type=style&index=0&id=1d2e1266&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2e1266"]])

export default __exports__